export default "__VITE_ASSET__CdBz66Dy__"